import { FC } from 'react';

import { StaticPercentSpan } from '@myn/mui';

import { PercentFieldProps } from '../types.js';

type Props = Omit<PercentFieldProps, 'variant' | 'scale' | 'color'>;

const PercentVariant: FC<Props> = ({
  value,
  decimalLimit,
  isEmptyValueHidden = false,
}) => {
  const isValidValue = !!value || value === 0;

  if (isEmptyValueHidden || !isValidValue) {
    return null;
  }

  return (
    <StaticPercentSpan
      number={value}
      options={{
        minDecimals: decimalLimit,
        maxDecimals: decimalLimit,
        min: 0,
      }}
    />
  );
};
export default PercentVariant;
